import { useState } from 'react';
import * as R from 'ramda';

import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';
import { ElementErrorTask } from '@atom/types/inventory';

import classes from './moveElement.module.css';

const ERROR_LIMIT = 30;

const styles = {
  icon: {
    marginRight: '1rem',
  },
};

interface Props {
  errors: ElementErrorTask[];
  message: string;
}

const ErrorSection = ({ errors, message }: Props) => {
  const [, { Link }] = useNavigation();

  const [expanded, setExpanded] = useState<boolean>(false);

  const errorsCount = errors.length;
  const displayAssetErrors = R.take(ERROR_LIMIT, errors);
  const leftoverAssetErrorsCount =
    errorsCount > ERROR_LIMIT ? errorsCount - ERROR_LIMIT : null;
  const showErrors = errorsCount > 0;

  const expandIcon = expanded ? 'expand_more' : 'expand_less';

  return showErrors ? (
    <div className={classes.errorSection}>
      <div className={classes.sectionHeader}>
        <Icon style={styles.icon} color={colors.brand.red}>
          error_outline
        </Icon>
        <div className={classes.sectionTextContainer}>
          <div>{message}</div>
          <div className={classes.count}>{`(${errorsCount})`}</div>
        </div>
        <IconButton onClick={() => setExpanded(!expanded)} edge="end">
          <Icon>{expandIcon}</Icon>
        </IconButton>
      </div>
      {expanded && (
        <div className={classes.errorList}>
          {displayAssetErrors.map(error => {
            const taskLink = `/workOrders/${error.workOrderId}?view=TASKS&task=${error.taskId}`;

            return (
              <div className={classes.taskLink}>
                <Link key={error.taskName} to={taskLink} target="_blank">
                  {error.taskName}
                </Link>
              </div>
            );
          })}
          {!R.isNil(leftoverAssetErrorsCount) && (
            <div>{`+ ${leftoverAssetErrorsCount} more`}</div>
          )}
        </div>
      )}
    </div>
  ) : (
    <div />
  );
};

export default ErrorSection;
